import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { CounterContext } from 'context/bestContext';
import { useHistory, Link } from 'react-router-dom';
import { ThemeContext } from 'context/themeContext';
import MainContext from 'MainContext';
import Profile from "asset/profile.svg";
import Button from 'components/button';
import LoginModal from 'containers/login/login-modal';
import { t } from 'i18next';

const CartIcon = styled.div`
  width: 2.29vw;
  height: 2.29vw;
  cursor: pointer;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 2.3vw;

  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    width: 4.5vw;
    height: 4.5vw;
    font-size: 5vw;
  }

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    display: none;
  }
`;

// const ShoppingBagFullIcon = styled.div`
//   width: 2.29vw;
//   height: 2.29vw;
//   opacity: ${(props) => (props.selected ? '1' : '0')};

//   display: flex;
//   justify-content: center;
//   color: ${(props) => props.theme.icons};
//   font-size: 1.8vw;
// `;
const ShoppingBagCounter = styled.div`
  background-color: ${(props) => props.theme.redColor};
  height: 0.4vw;
  font-size: 0.8vw;
  padding: 0.4vw;
  border-radius: 1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  right: ${(props) => (props.rtlDirection ? 'unset' : '0.8vw')};
  left: ${(props) => (props.rtlDirection ? '0.8vw' : 'unset')};
  top: -0.5vw;
  color: ${(props) => props.theme.textPrimary};
  font-family: Roboto;
`
const NextIcon = styled.div`
  width: 0.884vw;
  height: 0.884vw;
  transition: 200ms linear;

  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 0.9vw;
  
  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    font-size: 2.5vw;
    width: 3.5vw;
    height: 3.5vw;
  }

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    font-size: 3.5vw;
    width: 5vw;
    height: 5vw;
    align-items: center;
  }
`;

const BackIcon = styled.div`
  width: 0.884vw;
  height: 0.884vw;
  transition: 200ms linear;

  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 0.9vw;

  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    font-size: 2.5vw;
    width: 3.5vw;
    height: 3.5vw;
  }

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    font-size: 3.5vw;
    width: 5vw;
    height: 5vw;
    align-items: center;
  }
`;

const NavWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 4.008vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  direction: ${(props) => (props.rtlDirection ? 'rtl' : 'ltr')};
  top: 0;
  right: 0;

  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    height: 6vw;
    margin-top: 2vw;
  }

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    margin-top: 4vw;
    height: 8.008vw;
  }
`;
const LeftAndRightWrapper = styled.div`
  display: flex;
  align-items: center;
  direction: ltr;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`;
const Circle = styled.div`
  position: relative;
  width: 2.742vw;
  height: 2.742vw;
  margin-right: 1.04vw;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 300ms linear;
  padding: 0.2vw;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    border: 4px solid ${(props) => props.theme.textPrimary};
    box-sizing: border-box;
    z-index: -1;
  }
`;
const DefaultProfile = styled.img.attrs({
  src: Profile,
})`
    width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  cursor:pointer;
  
  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    width: 5vw;
    height: 5vw;
  }

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    width: 7.342vw;
    height: 7.342vw;
    margin-left: ${(props) => (props.rtlDirection ? '2.3vw' : '')};
    margin-right: ${(props) => (props.rtlDirection ? '' : '2.3vw')};
  }
`;

const NavItem = styled.div`
  position: relative;
  height: 4.008vw;
  display: flex;
  align-items: center;

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    height: 8.008vw;
  }

`;

const StyledImg = styled.img`
  width: 8.402vw;
  height: 3.008vw;
  object-fit: contain;
  margin-left: 1.56vw;
  margin-right: 1.56vw;
`;

const StyledProfile = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;

  background-color: ${(props) => props.theme.inputBackground};
  cursor:pointer;
  
  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    width: 7.342vw;
    height: 7.342vw;
  }

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    width: 7.342vw;
    height: 7.342vw;
  }
`;

const SubDomain = styled.div`
  font-size: 1.821vw;
  font-weight: bold;
  color: ${(props) => props.theme.textPrimary};
  margin-left: 1.192vw;
  margin-right: 1.192vw;
  letter-spacing: 0.3vw;
  
  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    font-size: 3.5vw;
  };

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    font-size: 6.97vw;
    margin-left: ${(props) => (props.rtlDirection ? '7vw' : '2.3vw')};
    margin-right: ${(props) => (props.rtlDirection ? '2.3vw' : '7vw')};
  }

`;
const ImageWrapper = styled.div`
  width: 1.613vw;
  height: 1.613vw;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.textPrimary};
  cursor: ${(props) => (props.active ? 'pointer' : 'not-allowed')};
  transition: 300ms linear;
  &:hover {
    background-color: ${(props) => props.active && props.theme.borderBackground};
  }

  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    width: 5vw;
    height: 5vw;
    margin-right: ${(props) => (props.rtlDirection ? '' : '1.3vw')};
    margin-left: ${(props) => (props.rtlDirection ? '1.3vw' : '')};
 
  } 

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    width: 5vw;
    height: 5vw;
    margin-right: ${(props) => (props.rtlDirection ? '' : '2.3vw')};
    margin-left: ${(props) => (props.rtlDirection ? '2.3vw' : '')};
  }
`;
const ImageWrapperLeft = styled(ImageWrapper)`
  margin-left: 0.937vw;
`;

const ImageWrapperRight = styled(ImageWrapper)`
  margin-left: 0.52vw;
`;
function NavBar() {
  const { showBasket, setShowBasket, showSetting, setShowSetting } = useContext(CounterContext);
  const { theme, logoPicture, rtlDirection, darkThemeSelected } = useContext(ThemeContext);
  const { profile } = useContext(MainContext).login;
  const {
    checkoutInvoice,
    basketOrders,
  } = useContext(MainContext).cart;
  const checkoutOrders = checkoutInvoice.orders ? checkoutInvoice.orders : basketOrders;
  let partsNumber = 0;

  let history = useHistory();
  const [subDomain, setSubDomain] = useState('');
  const [showLoginModal, setShowLoginModal] = useState(false);

  const getFamilyfromSubDomain = async () => {
    var host = decodeURIComponent(window.location.host);
    var value = host.split('.')[0];
    if(value=='directe-offerte')
      value='Rezscale';
    if(host=='quotation.admixlab.com')
      value='Admix Lab';
    if(host=='quote.adddit.eu')
      value='Adddit';
    if(host=='print.3dbrinter.com')
	  value='3DBrinter';
    if(host=='shop.exact3design.com')
	  value='Exact3Design';
 
    setSubDomain(value);
  };
  useEffect(() => {
    getFamilyfromSubDomain();
  });
const contextHistory = history.entries ? history.entries.slice(0, history.index).map(entry => entry.pathname) : [];
const nextHistory = history.entries ? history.entries.slice(history.index + 1).map(entry => entry.pathname) : [];
  const onBackClick = async () => {
    history.goBack();
  }
  const onNextClick = async () => {
    history.goForward();
    

  }

  useEffect(() => {
    if (showLoginModal) {
      setShowLoginModal(false);
    }
  }, [profile]);

  // set part number to basket counter
  checkoutOrders.map((order) => {
    partsNumber += order.quantity;
  });
  return (
    <>
      <LoginModal
              open={showLoginModal}
              toggle={setShowLoginModal}
              guest={profile.user_type === 'Guest'}
              guestId={profile._id}
              skipable={true}
              
        />
    <NavWrapper rtlDirection={rtlDirection}>
      
    <NavItem>
    
      
        {logoPicture ? (
          <StyledImg
            src={
              `${process.env.REACT_APP_STATISTIC_SERVICE_URL}/avatar/` +
              logoPicture +
              `?${new Date().getTime()}`
            }
          />
        ) : (
          <SubDomain theme={theme}>{subDomain}</SubDomain>
        )}
        <LeftAndRightWrapper theme={theme}>
            
            <ImageWrapperLeft theme={theme} active={true} onClick={onBackClick}>
              <BackIcon
                className="icon-back"
                theme={theme}
                active={contextHistory.length > 1}
                darkThemeSelected={darkThemeSelected}
              />
            </ImageWrapperLeft>
            <ImageWrapperRight theme={theme} active={true} onClick={onNextClick}>
              <NextIcon
                className="icon-next"
                theme={theme}
                active={nextHistory.length > 0}
              />
            </ImageWrapperRight>
        </LeftAndRightWrapper>
      </NavItem>
      <NavItem>
        {profile.cellphone && (
          <>
            {profile.user_type === 'Guest' && (
              <Button
                theme={theme}
                text={t('navBar.Login/Register')}
                onClick={() => {
                  setShowLoginModal(true);
                }}
                style={{ margin: '1vw' }}
                />
            )}
              <CartIcon
                className={partsNumber > 0 ? 'icon-shopping-bag-full' : 'icon-shopping-bag-empty'}
                theme={theme}
                onClick={() => {
                  setShowBasket(!showBasket);
                }}
              >
                 {partsNumber > 0 && (
                  <ShoppingBagCounter rtlDirection={rtlDirection} theme={theme}>
                    {partsNumber}
                  </ShoppingBagCounter>
                )}
              </CartIcon>
            {profile.user_type !== 'Guest' &&
          <Circle theme={theme} onClick={() => setShowSetting(true)}>
            {(
              profile.profile_picture ? (
              <StyledProfile
                theme={theme}
                src={`${process.env.REACT_APP_STATISTIC_SERVICE_URL}/avatar/${profile.profile_picture}`}
              />) :
              (<DefaultProfile/>)
            )}
          </Circle>
            }
            
          </>
        )}
      </NavItem>
    </NavWrapper>
    </>
  );
}

export default NavBar;
